import { FC } from "react";
import InfoTileContainer from "../../../../../shared-elements/info-tile/info-tile-container.component";
import InfoTileComponent from "../../../../../shared-elements/info-tile/info-tile.component";
import "./assets.scss";

interface AssetStatisticsSectionProps {
  equipmentQuantityData: any;
  isLoadingEquipmentQuantity: boolean;
  gatewaySummary: any;
  isLoadingGatewaySummary: boolean;
  siteSummary: any;
  isLoadingSiteSummary: boolean;
  lightSummary: any;
  isLoadingLightSummary: boolean;
  modalHandler: any;
}

const AssetStatisticsSection: FC<AssetStatisticsSectionProps> = ({
  equipmentQuantityData,
  isLoadingEquipmentQuantity,
  gatewaySummary,
  isLoadingGatewaySummary,
  siteSummary,
  isLoadingSiteSummary,
  lightSummary,
  isLoadingLightSummary,
  modalHandler,
}) => {
  return (
    <div className="my-4 asset-statistics-grid">
      {/* Left Top: Equipment Quantity */}
      <div className="asset-statistics-grid__equipment">
        <InfoTileContainer header="Equipment Quantity">
          <InfoTileComponent
            title="Luminaire Quantity"
            value={equipmentQuantityData?.totalLight || 0}
            onClickEvent={
              Number(equipmentQuantityData?.totalLight) > 0
                ? () => modalHandler(2, "quantity")
                : null
            }
            className={
              Number(equipmentQuantityData?.totalLight) > 0
                ? "cursor-pointer link-color"
                : ""
            }
            isLoading={isLoadingEquipmentQuantity}
          />

          {/* <InfoTileComponent
          title="Sensor Quantity"
          value={equipmentQuantityData?.sensorQuantity || 0}
          onClickEvent={
            Number(equipmentQuantityData?.sensorQuantity) > 0
              ? () => modalHandler(1, "quantity")
              : null
          }
          className={
            Number(equipmentQuantityData?.sensorQuantity) > 0
              ? "cursor-pointer link-color"
              : ""
          }
          isLoading={isLoadingEquipmentQuantity}
        /> */}

          <InfoTileComponent
            title="Gateway Quantity"
            value={equipmentQuantityData?.totalGateway || 0}
            onClickEvent={
              Number(equipmentQuantityData?.totalGateway) > 0
                ? () => modalHandler(3, "quantity")
                : null
            }
            className={
              Number(equipmentQuantityData?.totalGateway) > 0
                ? "cursor-pointer link-color"
                : ""
            }
            isLoading={isLoadingEquipmentQuantity}
          />
        </InfoTileContainer>
      </div>

      {/* Right (spans 2 rows): Asset Status Info */}
      <div className="asset-statistics-grid__status">
        <InfoTileContainer header="Asset Status Info">
          <InfoTileComponent
            title="Total Gateways"
            value={equipmentQuantityData?.totalGateway || 0}
            isLoading={isLoadingEquipmentQuantity}
          />

          <InfoTileComponent
            title="Online Gateways"
            value={gatewaySummary?.totalOnlineGateway || 0}
            isLoading={isLoadingGatewaySummary}
          />

          <InfoTileComponent
            title="Offline Gateways"
            value={gatewaySummary?.totalOfflineGateway || 0}
            isLoading={isLoadingGatewaySummary}
          />

          <InfoTileComponent
            title="Total Lights"
            value={equipmentQuantityData?.totalLight || 0}
            isLoading={isLoadingEquipmentQuantity}
          />

          <InfoTileComponent
            title="Total Lights (On)"
            value={lightSummary?.totalOnlineLight || 0}
            isLoading={isLoadingLightSummary}
          />

          <InfoTileComponent
            title="Total Lights (Off)"
            value={lightSummary?.totalOfflineLight || 0}
            isLoading={isLoadingLightSummary}
          />
          <InfoTileComponent
            title="Total Lights in Floor Plan"
            value={lightSummary?.totalFloorPlanLight || 0}
            onClickEvent={
              Number(lightSummary?.totalFloorPlanLight) > 0
                ? () => modalHandler(null, "TotalLightsFloorplan")
                : null
            }
            className={
              Number(lightSummary?.totalFloorPlanLight) > 0
                ? "cursor-pointer link-color"
                : ""
            }
            isLoading={isLoadingLightSummary}
          />
        </InfoTileContainer>
      </div>

      {/* Left Bottom: Site Summary */}
      <div className="asset-statistics-grid__site">
        <InfoTileContainer header="Site Summary">
          <InfoTileComponent
            title="Total Sites"
            value={siteSummary?.totalSite || 0}
            isLoading={isLoadingSiteSummary}
          />

          <InfoTileComponent
            title="Total Blocks"
            value={siteSummary?.totalBlock || 0}
            onClickEvent={
              Number(siteSummary?.totalBlock) > 0
                ? () => modalHandler(null, "TotalBlocks")
                : null
            }
            className={
              Number(siteSummary?.totalBlock) > 0
                ? "cursor-pointer link-color"
                : ""
            }
            isLoading={isLoadingSiteSummary}
          />
        </InfoTileContainer>
      </div>
    </div>
  );
};

export default AssetStatisticsSection;
